import React from 'react'
import {
  Box, Text, ImageLoader,
} from '@usap/uicomponents'
import lastRecordStyle from '../utils/lastRecordStyle'
import SetKitDisplay from '../../../SetKitDisplay'
import { minHeightCss, fontMinHeightCss } from '../constant'
import ReasonsList from './ReasonList'
import ImageUploads from './ImageUpload'

const OrderItem = ({
  orderItems,
  isDesktop,
  selectedImages,
  filesUpload,
  reasonLabel,
}) => {
  const borderSeparator = isDesktop ? { borderRight: '1px solid #CCCACA' } : { borderBottom: 'none' }

  return (
    <>
      {orderItems.map((items, i) => (
        <Box
          key={items.order_item_id}
          direction={isDesktop ? 'row': 'column'}
          style={lastRecordStyle(i)}
          pad="16px"
        >
          <Box
            key={`Box2${items.order_item_id}`}
            direction="row"
            pad={{ bottom: '16px' }}
            style={borderSeparator}
            width="95%"
          >
            <Box
              key={`Box3${items.order_item_id}`}
              alignSelf="start"
              justify="center"
              width="200px"
            >
              <ImageLoader
                key={`RMA${items.order_item_id}`}
                width="100%"
                height="100%"
                src={items.ImageURL}
                fit="contain"
                alt={items.sku_title}
                cloudinaryParams="h_125,w_125"
                fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
              />
            </Box>
            <Box
              key={`Box4${items.order_item_id}`}
              direction="column"
              margin={{ left: '16px', right: isDesktop ? '16px': 'unset' }}
              width="80%"
            >
              <Text
                key={`txt1${items.order_item_id}`}
                size="14px"
                style={fontMinHeightCss}
                dangerouslySetInnerHTML={{ __html: items.brandText }}
              />
              <Text
                key={`txt2${items.order_item_id}`}
                size="14px"
                style={minHeightCss}
                dangerouslySetInnerHTML={{ __html: items.sku_title }}
              />
              <Text key={`txt3${items.order_item_id}`} size="14px" style={minHeightCss}>
                Part no.:
                {' '}
                {items.sku}
              </Text>
              <Text key={`txt4${items.order_item_id}`} size="14px" style={minHeightCss}>
                Qty:
                {' '}
                {items.returnQty}
              </Text>
              <Text key={`txt5${items.order_item_id}`} size="14px" style={minHeightCss}>
                Unit Price:
                {' '}
                $
                {parseFloat(items.list_price).toFixed(2)}
              </Text>
              <Text key={`txt6${items.order_item_id}`} size="14px" style={fontMinHeightCss}>
                Item Total:
                {' '}
                $
                {(parseFloat(items.list_price) * items.returnQty).toFixed(2)}
              </Text>

              {isDesktop && items.parentSku && (
              <Box key={`parentSku${items.order_item_id}`} pad={{ right: '16px', top: '16px' }}>
                <SetKitDisplay
                  key={`hparentSKU${items.order_item_id}`}
                  parentSku={items.parentSku}
                  showPartNumber={false}
                />
              </Box>
              )}
            </Box>
          </Box>
          <Box
            key={`Box6${items.order_item_id}`}
            width={isDesktop ? '45%':'100%'}
            margin={{ vertical: '16px', horizontal: isDesktop ? '16px':'unset' }}
          >
            {!isDesktop && items.parentSku && (
              <Box key={`Box7${items.order_item_id}`} pad={{ right: '0px', top: '16px' }}>
                <SetKitDisplay
                  key={`hparentSKU2${items.order_item_id}`}
                  parentSku={items.parentSku}
                  showPartNumber={false}
                />
              </Box>
            )}
            <ReasonsList
              reasons={items.reasons}
              isDesktop={isDesktop}
              reasonLabel={reasonLabel}
            />
            <ImageUploads
              sku={items.sku}
              selectedImages={selectedImages}
              isDesktop={isDesktop}
              filesUpload={filesUpload}
            />
          </Box>
        </Box>
      ))}
    </>
  )
}

export default OrderItem
